// extracted by mini-css-extract-plugin
export default {"part":"ee3e2d8f921c"};